import type { GameState } from "./GameState";
import { bus } from "../core/EventBus";

/** Nivel de seguridad por localización (punto 23). No es solo puntuación. */
export class SecuritySystem {
  constructor(private state: GameState) {}

  get(location: string): number {
    return this.state.security[location] ?? 0;
  }

  init(location: string, value: number): void {
    if (this.state.security[location] == null) {
      this.state.security[location] = value;
      this.state.persist();
      bus.emit("SECURITY_CHANGED", { location, value });
    }
  }

  set(location: string, value: number): void {
    const v = Math.max(0, Math.min(100, Math.round(value)));
    this.state.security[location] = v;
    this.state.persist();
    bus.emit("SECURITY_CHANGED", { location, value: v });
  }

  change(location: string, delta: number): void {
    this.set(location, this.get(location) + delta);
  }
}
